import { useCallback } from 'react'
import { Dialog, DialogContent, DialogTitle, makeStyles, IconButton, Icon } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { FONT_WEIGHTS } from '../../../../../utils'
import { purple } from '@material-ui/core/colors'

const POLICY1 = `As a client of Skiptown's grooming service, I understand and agree that there could be complications involved in grooming my dog, named on this document. I have informed Skiptown of all behavioral traits and health concerns that may affect the safety of my pet and/or the stylists and/or technicians. I further understand that Skiptown will take any necessary precautions when grooming pets that are consistent with standard grooming practices, and also the information that I have provided to them. I hereby release, waive, discharge and agree not to sue Skiptown, its owners, officers, and/or employees, from all liability for any loss or damage, or any claim therefore, as a result of the grooming of my pet, including injury to or death of my pet, that may occur while my pet is in the custody of Skiptown or related thereto, unless caused by a willful act or violation of law by Skiptown or its employees.`

const POLICY2 = `Dogs with severely matted coats require extra attention and will incur an added fee. Skiptown will not cause serious or undue stress to pets by de-matting. Mats can be difficult to remove, and may require the pet to be shaved. Removing a heavily matted coat can cause nicks, cuts, or abrasions. Heavy matting can also trap moisture and urine near the pet’s skin, allowing mold, fungus, or bacteria to grow, and/or revealing skin irritations that existed prior to the grooming process. After-effects of mat removal can include itchiness, redness, self-inflicted irritations or abrasions, and failure of hair to regrow. In some cases, pets may also exhibit brief behavioral changes. In the event my pet’s coat/fur is heavily matted, I authorize Skiptown to clip off or shave as much hair/fur as is necessary. I understand that in the case that my pet is heavily matted, there could be unseen sores, irritations and skin problems. If my pet's ears and tail are matted and need to be shaved, the severity could lead to hematomas. Skiptown is not responsible for underlying issues due to matting.`

const POLICY3 = `I hereby release Skiptown from any liability associated with any and all injuries or medical problems that may be uncovered and/or occur during the stripping and de-matting process. Should my pet need veterinarian care after or during the process of de-matting, I agree to pay any and all veterinarian fees.</div>It is known that there can be a variety of skin and hair coat care problems that may occur after a complete shave down of a dog, particularly the double coated dogs or those often referred to as the fur bearing rather than hair bearing dogs. Those problems may be the following but not limited to: - Loss of hair growth - “Coat Funk”- the coat not growing back in the same texture and or color prior to shaving - Bald patches - Hyper pigmentation of the skin- Darkening of the skin where the coat has not grown back - Sunburn - Loss of Guard Coat- Top Layer of Coat - Coat re-growth in different direction (cowlick’s) Knowing that any and all of the above conditions can occur I authorize my Groomer to shave down my pet and do not hold Skiptown liable if any and all of the above conditions occur. My signature below certifies that I have read, understand, and agree with the
provisions of this document.`

const useStyles = makeStyles(() => ({
	content: { display: 'flex', flexDirection: 'column', gap: '.6rem' },
	header: {
		display: 'flex',
		marginBottom: '.8rem',
		justifyContent: 'flex-end',
		gap: '.4rem',
		'& div:nth-child(2)': {
			flex: 1
		}
	},
	infoIconContainer: {
		display: 'flex'
	},
	infoIcon: {
		color: purple[500],
		fontSize: '1.18rem',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		overflow: 'unset'
	},
	titleText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem',
		textTransform: 'uppercase'
	},
	headerText: {
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '1rem'
	},
	policyText: {
		fontFamily: 'Nunito',
		fontSize: '1rem'
	}
}))

const DemattingTermsDialog = ({ open, onClose }) => {
	const classes = useStyles()

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	return (
		<Dialog
			PaperProps={{
				style: {
					width: 400,
					maxWidth: 400,
					maxHeight: 400,
					minWidth: 400
				}
			}}
			maxWidth="md"
			open={open}
			onClose={handleOnClose}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.infoIconContainer}>
						<Icon className={`fas fa-info-circle ${classes.infoIcon}`} />
					</div>
					<div className={classes.titleText}>Dematting Terms & Conditions</div>
					<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
						<Close onClick={handleOnClose} />
					</IconButton>
				</div>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<div className={classes.headerText}>Agreement</div>
				<div>{POLICY1}</div>
				<div>{POLICY2}</div>
				<div>{POLICY3}</div>
			</DialogContent>
		</Dialog>
	)
}

export default DemattingTermsDialog
